import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AudioComponent } from './components/audio/audio.component';
import { LegitComponent } from './components/legit/legit.component';
import { BannerComponent } from './components/banner/banner.component';
import { BioComponent } from './components/bio/bio.component';
import { ThisIszmeShowingOffComponent } from './components/this-iszme-showing-off/this-iszme-showing-off.component';
import { WorkfromhomeComponent } from './components/workfromhome/workfromhome.component';

@NgModule({
  declarations: [
    AppComponent,
    AudioComponent,
    LegitComponent,
    BannerComponent,
    BioComponent,
    ThisIszmeShowingOffComponent,
    WorkfromhomeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
